// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"625":"6aa7085716efbac6","698":"963eb382bba4704c"}[chunkId] + ".js";
};